import type { SettlementDocumentType } from '../document/document-types';

const invoices = ['COMMERCIAL_INVOICE', 'CUSTOMS_INVOICE'] as const;
const shipping = ['COMMERCIAL_INVOICE', 'PACKING_LIST'] as const;
const certificate = ['BENEFICIARY_CERTIFICATE'] as const;
const all = [...shipping, 'CUSTOMS_INVOICE', ...certificate] as const;

export const settlementFields = [
  { field: 'invoiceNumber', label: '发票号', types: all },
  { field: 'invoiceDate', label: '单证日期', types: all, inputType: 'date' },
  { field: 'contractNumber', label: '合同号', types: shipping },
  { field: 'lcNumber', label: '信用证号', types: [...shipping, ...certificate] },
  { field: 'eta', label: '预计到港 ETA', types: shipping },
  { field: 'countryOfOrigin', label: '原产国', types: invoices },
  { field: 'destinationCountry', label: '目的国', types: ['CUSTOMS_INVOICE'] },
  { field: 'exchangeRate', label: '汇率（本币/发票币种）', types: ['CUSTOMS_INVOICE'] },
  { field: 'issuingBankName', label: '开证行名称 TO', types: certificate },
  { field: 'issuingBankAddress', label: '开证行地址', types: certificate },
  { field: 'billOfLadingNumber', label: '提单号 B/L No.', types: certificate },
  { field: 'shipmentDate', label: '装运日期', types: certificate, inputType: 'date' },
  { field: 'dispatchDays', label: '装运后寄单天数', types: certificate },
  { field: 'dispatchedDocuments', label: '已寄送单据清单', types: certificate },
  { field: 'certificateStatement', label: '受益人声明原文', types: certificate },
  { field: 'beneficiaryRepresentative', label: '代表受益人', types: certificate },
] as const satisfies readonly { field: string; label: string; types: readonly SettlementDocumentType[]; inputType?: string }[];

export const settlementItemFields = [
  { field: 'hsCode', label: 'HS 编码', types: invoices },
  { field: 'cartonNumber', label: '箱号', types: ['PACKING_LIST'] },
  { field: 'netWeight', label: '净重 (kg)', types: ['PACKING_LIST'] },
] as const;

export const settlementShippingFields: Partial<Record<SettlementDocumentType, readonly string[]>> = {
  COMMERCIAL_INVOICE: ['vessel', 'voyageNumber', 'portOfLoading', 'portOfDischarge', 'etd'],
  PACKING_LIST: ['vessel', 'voyageNumber', 'portOfLoading', 'portOfDischarge', 'etd', 'consignee', 'items.marks', 'items.packages', 'items.grossWeight', 'items.measurement'],
  BENEFICIARY_CERTIFICATE: ['vessel', 'voyageNumber'],
};
